import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import ServiceDetailLayout from "../components/ServiceDetailLayout";
import banner1 from "../assets/resolution.png";
import { IoMdWarning, IoMdCalendar, IoMdCheckmarkCircle } from "react-icons/io";
import Footer from "../ones/Footer";
import TestimonialSlider from "../ones/TestimonialSlider";

export default function RESOLUTION() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready)
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );

  const hero = {
    kicker: "Resolution Desk",
    title: "Unfiled Returns & Penalty Relief",
    subtitle: "Structured clearance, remediation, and remission support",
    description:
      "We rebuild missing monthly returns, craft penalty remission narratives, and navigate TRA correspondence so outstanding filings stop hurting your compliance score.",
    image: banner1,
    chips: ["Clear outstanding returns", "Penalty relief", "Negotiated submissions"],
  };

  const highlights = [
    { icon: <IoMdWarning />, title: "Focused diagnosis", detail: "Identify missing months, due amounts, and interest exposure." },
    { icon: <IoMdCalendar />, title: "Phased filing", detail: "Sequence submission batches for fast TRA acceptance." },
    { icon: <IoMdCheckmarkCircle />, title: "Penalty relief", detail: "Prepare remission packets and negotiate waiver considerations." },
  ];

  const timeline = [
    { title: "Assess history", detail: "Review TRA portal, outline gaps, and capture penalties." },
    { title: "File prioritized returns", detail: "Batch compile, validate, and lodge missing obligations." },
    { title: "Remission & monitoring", detail: "Submit penalty mitigation and confirm TRA updates." },
  ];

  const extra = {
    ctaTitle: "Need to clear your books?",
    ctaCopy: "Call us for a structured plan to resolve unfiled returns and restore compliance breathing room.",
  };

  return (
    <>
      <ServiceDetailLayout hero={hero} highlights={highlights} timeline={timeline} extra={extra} />
      <TestimonialSlider />
      <Footer />
    </>
  );
}
